export default __webpack_public_path__ + "static/media/landing-Word-Objeto2.d1313bef.webp";